import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";

import { Transporter } from "./../../resources";

@Injectable()
export class TransporterService extends BaseDataService<Transporter> {
  constructor(http: HttpService) {
    super(http, "transporter");
  }

  createInstance(options: any): Transporter {
    return new Transporter(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
